/** Ocean Pilot (cabinet): keys are the Russian source strings, exactly as they appear in the code. */
export default {
  en: {
    'Бесплатная доставка для заказов от {sum}': 'Free shipping for orders from {sum}',
    'Скидка {p}%': 'Discount {p}%',
    'по промокоду {code}': 'with promo code {code}',
    'Скидка {sum}': 'Discount {sum}',
    'Без скидки': 'No discount',
    'русский': 'Russian',
    'английский': 'English',
    'вы': 'you',
    'участник команды': 'team member',
    'система': 'system',
    'Подготовь на сегодня рассылку клиентам, которые покупали кофе больше месяца назад. Предложи бесплатную доставку от 40 евро. Пришли на согласование.': 'Prepare today’s campaign for customers who bought coffee more than a month ago. Offer free shipping from €40. Send it for approval.',
    'Убери слово «последний», спокойнее, исключи купивших за 7 дней.': 'Remove the word “last”, make it calmer, exclude those who bought in the last 7 days.',
    'Когда будет 100 кликов или 10 заказов, пришли отчёт.': 'When there are 100 clicks or 10 orders, send me a report.',
    'Рассылай.': 'Send it.',
    'нужен ответ': 'answer needed',
    'черновик': 'draft',
    'ждёт согласования': 'awaiting approval',
    'согласован': 'approved',
    'запланирован': 'scheduled',
    'идёт отправка': 'sending',
    'пауза': 'paused',
    'передан в отправку': 'handed to sending',
    'окно пропущено': 'window missed',
    'остановлен MailOcean': 'stopped by MailOcean',
    'ждёт решения': 'awaiting decision',
    'согласовано': 'approved',
    'возвращено': 'returned',
    'аннулировано': 'voided',
    'отозвано': 'revoked',
    'истекло': 'expired',
    'ждёт времени отправки': 'waiting for send time',
    'все письма созданы': 'all emails created',
    'уникальных кликов людей': 'unique human clicks',
    'оплаченных заказов': 'paid orders',
    'атрибутированной выручки': 'attributed revenue',
    'контакт удалён': 'contact deleted',
    'нет email': 'no email',
    'нет согласия': 'no consent',
    'частотный лимит': 'frequency cap',
    'в подавлениях': 'suppressed',
    'другое': 'other',
    'Тема': 'Subject',
    'Прехедер': 'Preheader',
    'Заголовок': 'Title',
    'Текст': 'Text',
    'Кнопка': 'Button',
    'Ссылка кнопки': 'Button link',
    'AI': 'AI',
    'правила': 'rules',
    'ручная правка': 'manual edit',
    'Аудитория': 'Audience',
    'Email': 'Email',
    'Web Push': 'Web Push',
    'Telegram-бот': 'Telegram bot',
    'Мобильный push': 'Mobile push',
    'AI выключен для пространства': 'AI is turned off for this workspace',
    'ключ AI не настроен на этой установке': 'the AI key is not configured on this installation',
    'Работает детерминированный планировщик: весь сценарий доступен без AI': 'Rules-based planner: the whole flow works without AI',
    'Планы предлагает модель; сервер проверяет каждое поле': 'Plans are proposed by the model; the server checks every field',
    'Правила (без AI)': 'Rules (no AI)',
    'Пилот выключен на этой установке.': 'Pilot is turned off on this installation.',
    'Пилот выключен на этой установке': 'Pilot is turned off on this installation',
    'Вы автор этой версии: согласовать её должен другой владелец или администратор пространства.': 'You are the author of this version: another owner or admin of the workspace must approve it.',
    'Значения на карточке устарели или число получателей набрано неверно. Обновите карточку и сверьте числа.': 'The values on the card are outdated or the number of recipients was entered incorrectly. Refresh the card and check the numbers.',
    'Вы видели другую версию плана. Обновите поток.': 'You saw a different version of the plan. Refresh the thread.',
    'План изменился, пока вы смотрели. Посмотрите последнюю версию.': 'The plan changed while you were looking. Check the latest version.',
    'Это согласование уже не ждёт решения.': 'This approval is no longer awaiting a decision.',
    'Срок согласования истёк — запросите новое.': 'The approval has expired — request a new one.',
    'Согласование уже запрошено.': 'Approval has already been requested.',
    'Согласовавший больше не владелец или администратор — нужно новое согласование.': 'The approver is no longer an owner or admin — a new approval is needed.',
    'У этой версии нет действующего согласования.': 'This version has no valid approval.',
    'Окно отправки пропущено: перенесите время в плане и согласуйте заново.': 'The sending window was missed: move the time in the plan and approve it again.',
    'Отрисованное письмо отличается от согласованного — запуск остановлен. Создайте новую версию.': 'The rendered email differs from the approved one — the launch is stopped. Create a new version.',
    'План уже запущен или закрыт — изменить его нельзя.': 'The plan is already launched or closed — it cannot be changed.',
    'Запуск остановлен MailOcean — возобновить его может только поддержка.': 'The launch was stopped by MailOcean — only support can resume it.',
    'Запуск сейчас в другом состоянии. Обновите карточку.': 'The launch is now in a different state. Refresh the card.',
    'Слишком много команд подряд — подождите немного.': 'Too many commands in a row — please wait a little.',
    'Домен отправителя не подтверждён.': 'The sender domain is not verified.',
    'Отправка заблокирована MailOcean.': 'Sending is blocked by MailOcean.',
    'Доступ к микрофону запрещён — разрешите его в настройках браузера или пишите текстом.': 'Microphone access is blocked — allow it in the browser settings or type your text.',
    'Браузер не разрешает распознавание речи на этой странице — пишите текстом.': 'The browser does not allow speech recognition on this page — type your text.',
    'Не расслышал. Попробуйте ещё раз ближе к микрофону.': 'Didn’t catch that. Try again closer to the microphone.',
    'Микрофон не найден.': 'Microphone not found.',
    'Распознавание речи недоступно: нет связи с сервисом браузера.': 'Speech recognition is unavailable: no connection to the browser service.',
    'Этот язык браузер не распознаёт.': 'The browser does not recognise this language.',
    'Распознавание остановилось ({code}).': 'Recognition stopped ({code}).',
    'Например (сценарий из стратегии, по шагам):': 'For example (the strategy scenario, step by step):',
    'Слышу:': 'Hearing:',
    'Поручение Пилоту: что, кому, когда и какой отчёт прислать': 'Command for Pilot: what, to whom, when and which report to send',
    'Поручение Пилоту': 'Command for Pilot',
    'Думаю…': 'Thinking…',
    'Отправить': 'Send',
    'Текст распознан браузером — проверьте его перед отправкой. Голос не согласует и не запускает рассылку.': 'Text recognised by the browser — check it before sending. Voice does not approve or launch a campaign.',
    'Голосовой ввод недоступен в этом браузере — пишите текстом.': 'Voice input is not available in this browser — type your text.',
    'Идёт запись — отпустите, чтобы закончить': 'Recording — release to finish',
    'Нажмите и держите, чтобы говорить': 'Press and hold to speak',
    'Нажмите и говорите (или держите пробел)': 'Press and speak (or hold Space)',
    '{s} с / {max}': '{s} s / {max}',
    'Голос': 'Voice',
    'Отмена': 'Cancel',
    'Язык распознавания': 'Recognition language',
    'Прочитать вслух (без адресов)': 'Read aloud (no addresses)',
    'Прочитать': 'Read aloud',
    'Получателей': 'Recipients',
    'найдено {found} · исключено {excluded}': 'found {found} · excluded {excluded}',
    'контрольная группа {n} (без письма)': 'control group {n} (no email)',
    'Отправка': 'Sending',
    'Предложение': 'Offer',
    'Отчёт': 'Report',
    'Отправитель · языки': 'Sender · languages',
    'Канал · цена': 'Channel · price',
    'бесплатно': 'free',
    'до €{amount}': 'up to €{amount}',
    'до {max} сообщений · {cost}': 'up to {max} messages · {cost}',
    'только получатели с адресом и согласием в этом канале': 'only recipients with an address and consent in this channel',
    'Лимит · оценка стоимости': 'Limit · cost estimate',
    'до {max} писем': 'up to {max} emails',
    '≈ {sum}': '≈ {sum}',
    'без согласия {n}': 'no consent {n}',
    'отписались {n}': 'unsubscribed {n}',
    'в подавлениях {n}': 'on suppression list {n}',
    'без email {n}': 'no email {n}',
    'без адреса или согласия в канале {n}': 'no address or consent in this channel {n}',
    'по исключениям плана {n}': 'by plan exclusions {n}',
    'контрольная группа {n} — письма не получат': 'control group {n} — will not get the email',
    'Аудитория {eligible} (найдено {matched}; исключено {excluded}{details})': 'Audience {eligible} (found {matched}; excluded {excluded}{details})',
    'Предупреждения:': 'Warnings:',
    'Предпросмотр': 'Preview',
    'Тёмная тема': 'Dark mode',
    'Письмо в тёмной теме почтового клиента (по стилям самого письма; клиенты, которые сами перекрашивают письма, покажут иначе)': 'The email in a mail client’s dark theme (based on the email’s own styles; clients that recolour emails themselves will show it differently)',
    'Тема:': 'Subject:',
    'Письмо версии {v} ({lang})': 'Email, version {v} ({lang})',
    'План · версия {v}': 'Plan · version {v}',
    '{n} получателей · {send} · {offer}': '{n} recipients · {send} · {offer}',
    'заменена следующей версией': 'replaced by the next version',
    'заменена': 'replaced',
    'Рассылка': 'Campaign',
    'Кто собрал эту версию': 'Who prepared this version',
    'Хеш версии: согласование привязано к нему': 'Version hash: the approval is tied to it',
    'Свернуть': 'Collapse',
    'Словами:': 'In words:',
    'Условие:': 'Condition:',
    'Исключить:': 'Exclude:',
    'Согласие, отписки и подавления проверяются ещё раз перед каждым письмом.': 'Consent, unsubscribes and suppressions are checked again before each email.',
    'Допущения:': 'Assumptions:',
    'Числа, ссылки и промокоды в письме — только из поручения и настроек Пилота.': 'Numbers, links and promo codes in the email come only from the command and the Pilot settings.',
    'Изменить': 'Edit',
    'Тестовое письмо': 'Test email',
    'Тестовое письмо отправлено на {email}': 'Test email sent to {email}',
    'На согласование': 'Send for approval',
    'Версия {v} отправлена на согласование': 'Version {v} sent for approval',
    'Что изменилось': 'What changed',
    'Версия {from} → {to}': 'Version {from} → {to}',
    'Комментарий:': 'Comment:',
    'Значимых изменений нет.': 'No significant changes.',
    'Было:': 'Before:',
    'Стало:': 'After:',
    'Вошли {added}, вышли {removed}': 'Joined {added}, left {removed}',
    'Текст заменён целиком.': 'Text replaced in full.',
    'Прежнее согласование не переносится.': 'The previous approval does not carry over.',
    'Новая версия согласуется заново.': 'The new version needs a new approval.',
    'Версия {v} согласована': 'Version {v} approved',
    'Возвращено с комментарием': 'Returned with a comment',
    'Согласование · версия {v}': 'Approval · version {v}',
    'Проверьте главное перед решением': 'Check the essentials before deciding',
    'Запросил {who} · {at} · действует до {until} · хеш': 'Requested by {who} · {at} · valid until {until} · hash',
    'Согласование относится только к этой версии; любая правка потребует нового.': 'The approval applies only to this version; any edit requires a new one.',
    'Это ваша версия. Если в пространстве есть другой владелец или администратор, согласует он; если нет — решение будет помечено «согласовано самостоятельно».': 'This is your version. If the workspace has another owner or admin, they approve it; if not, the decision is marked “self-approved”.',
    'Введите число получателей': 'Enter the number of recipients',
    '— для больших рассылок решение подтверждается набранным числом (больше {n}).': '— for large campaigns the decision is confirmed by typing the number (more than {n}).',
    'число получателей': 'number of recipients',
    'Комментарий (обязателен, если возвращаете)': 'Comment (required when returning)',
    'Комментарий к решению': 'Comment on the decision',
    'Согласовать версию {v}': 'Approve version {v}',
    'Вернуть с комментарием': 'Return with a comment',
    'Согласование не запускает рассылку: запуск — отдельная кнопка.': 'Approval does not start the campaign: launching is a separate button.',
    'Ждёт решения владельца или администратора пространства.': 'Waiting for a decision from the workspace owner or an admin.',
    'Согласование версии {v}:': 'Approval of version {v}:',
    'изменились настройки Пилота': 'Pilot settings changed',
    'согласовано самостоятельно': 'self-approved',
    'самостоятельно': 'self-approved',
    'В пространстве нет второго владельца или администратора': 'The workspace has no second owner or admin',
    'Подготовить запуск…': 'Prepare launch…',
    'Запустить может владелец или администратор.': 'The owner or an admin can launch.',
    'Запуск создан: письма уйдут в назначенное время': 'Launch created: emails will go out at the scheduled time',
    'Запуск создан: письма пошли в очередь': 'Launch created: emails are queued',
    'Запуск': 'Launch',
    'Запустить версию {v} для {n} получателей?': 'Launch version {v} for {n} recipients?',
    'Запуск уже создан — смотрите карточку отправки ниже.': 'The launch has already been created — see the sending card below.',
    'Эта карточка устарела: у плана другая версия или нет действующего согласования.': 'This card is outdated: the plan has another version or no valid approval.',
    'Запустить': 'Launch',
    'Отправка: {at}. Повторное нажатие не создаст второй запуск.': 'Sending: {at}. Pressing again will not create a second launch.',
    'Запустить может владелец или администратор пространства.': 'The owner or an admin of the workspace can launch.',
    'передано провайдеру': 'handed to provider',
    'в очереди': 'queued',
    'неизвестно': 'unknown',
    'прочие исходы': 'other outcomes',
    'не будет отправлено': 'will not be sent',
    'Погружение рассылки · версия {v}': 'Campaign deep dive · version {v}',
    'Старт {at}': 'Start {at}',
    'Создано писем: {c} из {total}': 'Emails created: {c} of {total}',
    'Остановлено MailOcean.': 'Stopped by MailOcean.',
    'Напишите в поддержку.': 'Please contact support.',
    'создано': 'created',
    'ждут создания': 'waiting to be created',
    'контрольная группа': 'control group',
    '«Передано провайдеру» не значит «доставлено». Письма с исходом «неизвестно» не повторяются автоматически, чтобы не было дублей.': '“Handed to provider” does not mean “delivered”. Emails with the outcome “unknown” are not retried automatically, so there are no duplicates.',
    'Пауза: новые письма не создаются': 'Paused: new emails are not created',
    'Пауза': 'Pause',
    'Пауза и отменить очередь': 'Pause and cancel the queue',
    'Пауза и отмена писем в очереди? Отменённые письма не уйдут и при возобновлении. Письма, уже принятые провайдером, не отзываются.': 'Pause and cancel the emails in the queue? Cancelled emails will not go out even after resuming. Emails already accepted by the provider cannot be recalled.',
    'Пауза, очередь отменена': 'Paused, queue cancelled',
    'Возобновить': 'Resume',
    'Отправка возобновлена': 'Sending resumed',
    'Отменить': 'Cancel',
    'Отменить запуск? Письма, которые ещё не созданы или стоят в очереди, не уйдут. Это окончательно.': 'Cancel the launch? Emails not yet created or queued will not go out. This is final.',
    'Запуск отменён': 'Launch cancelled',
    'Не будет отправлено: {list}.': 'Will not be sent: {list}.',
    'Запуск:': 'Launch:',
    'Запуск создан:': 'Launch created:',
    'отменено в очереди: {n}': 'cancelled in the queue: {n}',
    'Жду любое из:': 'Waiting for any of:',
    'Жду все условия:': 'Waiting for all conditions:',
    'Жду:': 'Waiting for:',
    'Без порога:': 'No threshold:',
    'наблюдает': 'watching',
    'сработал — отчёт отправлен': 'fired — report sent',
    'срок вышел — промежуточный итог': 'deadline passed — interim result',
    'отменён': 'cancelled',
    'Наблюдатель': 'Watcher',
    '{metric}: {now} из {gte}': '{metric}: {now} of {gte}',
    'сейчас {now}': 'now {now}',
    'Срок: до {at}; если порог не наберётся — придёт промежуточный итог с текущими числами.': 'Deadline: {at}; if the threshold is not reached, an interim result with the current numbers will arrive.',
    'Итог с текущими числами придёт {at}.': 'The result with the current numbers will arrive {at}.',
    'Сработал {at}.': 'Fired {at}.',
    'Срок был до {at}.': 'The deadline was {at}.',
    'Клики — только уникальные клики людей после фильтра ботов; открытия не считаются.': 'Clicks — only unique human clicks after bot filtering; opens are not counted.',
    'Порог достигнут': 'Threshold reached',
    'Промежуточный итог по сроку': 'Interim result at deadline',
    'Исправление отчёта': 'Report correction',
    'Отчёт · версия {v} · {reason}': 'Report · version {v} · {reason}',
    'Есть исправленная версия {v} — смотрите ниже в потоке.': 'There is a corrected version {v} — see below in the thread.',
    'Исправлено:': 'Corrected:',
    'версия {v} заменяет версию {from}': 'version {v} replaces version {from}',
    'заказов': 'orders',
    'возвратов': 'refunds',
    'Атрибутировано (не равно приросту)': 'Attributed (not equal to lift)',
    '{revenue} атрибутированных продаж': '{revenue} attributed sales',
    'заказ в течение {days} дн. после клика человека': 'order within {days} days after a human click',
    'заказ в течение {days} дн. после письма, без клика': 'order within {days} days after the email, no click',
    'возвратов {n} ({sum})': 'refunds {n} ({sum})',
    'Прирост (по контрольной группе)': 'Lift (vs control group)',
    'п.п.': 'pp',
    'с письмом {a}% ({b} из {c}) · без письма {d}% ({e} из {f})': 'with email {a}% ({b} of {c}) · without email {d}% ({e} of {f})',
    '95% интервал: {lo}…{hi} п.п. — {verdict}': '95% interval: {lo}…{hi} pp — {verdict}',
    'отличие значимо': 'the difference is significant',
    'отличие не доказано': 'the difference is not proven',
    'прирост не измеряется: нет контрольной группы': 'lift is not measured: there is no control group',
    'Клики': 'Clicks',
    'всего кликов {raw}: люди {human} · боты {bot} · сомнительные {suspect}': 'total clicks {raw}: humans {human} · bots {bot} · suspicious {suspect}',
    'проверяются {n}': 'under review {n}',
    'Открытия не считаются (Apple MPP и почтовые прокси открывают письма сами).': 'Opens are not counted (Apple MPP and mail proxies open emails by themselves).',
    'создано {c} · принято провайдером {a} · доставлено по событию провайдера {d}': 'created {c} · accepted by provider {a} · delivered per provider event {d}',
    'неизвестно {n}': 'unknown {n}',
    'в очереди {n}': 'queued {n}',
    'не отправлено: {list}': 'not sent: {list}',
    'Ссылка': 'Link',
    'Люди (уник.)': 'Humans (unique)',
    'Боты': 'Bots',
    'Сомнительные': 'Suspicious',
    'Оговорки и качество данных': 'Caveats and data quality',
    'Период: {from} — {to} · версия плана {rev} · правила кликов v{rules}': 'Period: {from} — {to} · plan version {rev} · click rules v{rules}',
    'Пересказ AI проверен по фактам отчёта': 'AI summary checked against the report facts',
    'Текст собран сервером из чисел отчёта': 'Text assembled by the server from the report numbers',
    'Запомнить в словаре': 'Remember in the vocabulary',
    'Можно ответить словами в поле ниже.': 'You can answer in words in the field below.',
    'Голос, распознан браузером': 'Voice, recognised by the browser',
    'уверенность {p}%': 'confidence {p}%',
    'Ошибка': 'Error',
    'Изменить версию {v}': 'Edit version {v}',
    'Будет создана новая версия; согласование — заново.': 'A new version will be created; approval starts over.',
    'Изменений нет.': 'No changes.',
    'Создать версию {v}': 'Create version {v}',
    'Название': 'Name',
    'Время отправки ({tz})': 'Send time ({tz})',
    'Сразу после запуска': 'Right after launch',
    'В назначенное время': 'At the scheduled time',
    'Дата': 'Date',
    'Время': 'Time',
    'Канал': 'Channel',
    'Шаблон канала': 'Channel template',
    'Ключ шаблона из «Каналы → Шаблоны»; в нём только переменные одобренного текста: subject, heading, paragraph, button_label, url, offer': 'Template key from “Channels → Templates”; it contains only variables of the approved text: subject, heading, paragraph, button_label, url, offer',
    'Только бесплатные каналы и без каскада: получат только контакты с адресом и маркетинговым согласием в этом канале. Смена канала — новое согласование.': 'Free channels only, with no cascade: only contacts with an address and marketing consent in this channel will receive it. Changing the channel needs a new approval.',
    'Тип предложения': 'Offer type',
    'Бесплатная доставка от суммы': 'Free shipping above an amount',
    'Скидка в процентах': 'Percentage discount',
    'Скидка суммой': 'Fixed-amount discount',
    'Порог, {cur}': 'Threshold, {cur}',
    'Скидка, %': 'Discount, %',
    'Скидка, {cur}': 'Discount, {cur}',
    'Промокод': 'Promo code',
    'только выданные магазином (настройки Пилота)': 'only codes issued by the shop (Pilot settings)',
    'в настройках Пилота нет промокодов': 'there are no promo codes in the Pilot settings',
    'без промокода': 'no promo code',
    'Текст письма': 'Email body',
    'Язык письма': 'Email language',
    'На языке подписчика': 'In the subscriber’s language',
    'Только по-русски': 'Russian only',
    'Только по-английски': 'English only',
    'Русский': 'Russian',
    'Английский': 'English',
    'только https и разрешённые в настройках хосты': 'https only and hosts allowed in the settings',
    'Футер с отпиской и причиной письма добавляется всегда. Чтобы изменить аудиторию, напишите команду в потоке — например «исключи купивших за 7 дней».': 'The footer with the unsubscribe link and the reason for the email is always added. To change the audience, write a command in the thread — for example “exclude those who bought in the last 7 days”.',
    'Отчёт и измерение': 'Report and measurement',
    'Прислать отчёт по порогу': 'Send a report when a threshold is reached',
    'Порог: {metric}': 'Threshold: {metric}',
    'не задан': 'not set',
    'Условия': 'Conditions',
    'любое из': 'any of',
    'все сразу': 'all at once',
    'Если не наберётся — итог через, ч': 'If not reached — result after, h',
    'Контрольная группа, %': 'Control group, %',
    '0–20; без неё прирост не измеряется': '0–20; without it the lift is not measured',
    'Лимит получателей': 'Recipient limit',
    'не меньше аудитории': 'not less than the audience',
    'Комментарий к правке (необязательно)': 'Edit comment (optional)',
    'Сервер не принял правку:': 'The server did not accept the edit:',
    'Пилот': 'Pilot',
    'Поручите рассылку словами или голосом: Пилот соберёт план с аудиторией и текстом, задаст вопросы, если что-то неясно, и пришлёт на согласование. Запускает всегда человек.': 'Describe the campaign in words or by voice: Pilot will build a plan with the audience and copy, ask questions if anything is unclear, and send it for approval. A person always launches it.',
    'Обратитесь к администратору MailOcean.': 'Contact the MailOcean administrator.',
    'Словарь': 'Vocabulary',
    'Настройки Пилота': 'Pilot settings',
    'Решения о запуске принимает человек.': 'A person makes launch decisions.',
    'Например: подготовь на завтра рассылку тем, кто не покупал 60 дней, скидка 10%, пришли на согласование': 'For example: prepare tomorrow’s campaign for people who have not bought in 60 days, 10% discount, send it for approval',
    'Роль «наблюдатель» только читает потоки.': 'The “observer” role can only read threads.',
    'Поручения': 'Commands',
    'последние сверху': 'latest first',
    'Поручений ещё нет': 'No commands yet',
    'Первое поручение — в поле выше. Пилот ничего не отправит без согласования и отдельного запуска.': 'Write your first command in the field above. Pilot sends nothing without approval and a separate launch.',
    'есть план': 'has a plan',
    'без плана': 'no plan',
    'обновлено {when}': 'updated {when}',
    'Поток не найден.': 'Thread not found.',
    'Все поручения': 'All commands',
    'Пока пусто': 'Nothing here yet',
    'Напишите поручение ниже или выберите пример.': 'Write a command below or pick an example.',
    'Пилот разбирает поручение…': 'Pilot is working through the command…',
    'Роль «наблюдатель» только читает поток.': 'The “observer” role can only read this thread.',
    'Рассылка завершена или отменена — для новой начните новое поручение.': 'The campaign is finished or cancelled — start a new command for a new campaign.',
    'Ответьте на вопрос выше или напишите новое поручение': 'Answer the question above or write a new command',
    'Поток поручения': 'Command thread',
    'Пульт': 'Control panel',
    'плана ещё нет': 'no plan yet',
    'Опишите рассылку: кому, что предложить, когда и какой отчёт прислать. Пилот соберёт план, но сам ничего не отправит.': 'Describe the campaign: to whom, what to offer, when, and what report to send. Pilot will build a plan but will not send anything itself.',
    'Версия': 'Version',
    'Согласование': 'Approval',
    'не запрошено': 'not requested',
    'Обновлён': 'Updated',
    'Отменить план? Писем ещё не было; поток останется в истории.': 'Cancel the plan? No emails have been sent; the thread stays in history.',
    'План отменён': 'Plan cancelled',
    'Отменить план': 'Cancel plan',
    'Словарь Пилота': 'Pilot vocabulary',
    'Как слова поручений связаны с вашими данными. Если слова нет в словаре, Пилот спросит, а не угадает.': 'How the words of commands map to your data. If a word is not in the vocabulary, Pilot will ask rather than guess.',
    'Словарь пуст': 'The vocabulary is empty',
    'Добавьте товар или группу клиентов — например «кофе» → категория coffee в событии оплаты.': 'Add a product or a customer group — for example “coffee” → category coffee in the payment event.',
    'Слово': 'Word',
    'Значит': 'Means',
    'Язык': 'Language',
    'Добавлено': 'Added',
    'товар: {f}': 'product: {f}',
    'сегмент {s}': 'segment {s}',
    'любой': 'any',
    'Удалить {term}': 'Delete {term}',
    'Добавить слово': 'Add a word',
    'Слово или фраза': 'Word or phrase',
    'как вы пишете в поручениях: «кофе», «постоянные»': 'as you write it in commands: “coffee”, “regulars”',
    'Товар': 'Product',
    'Сегмент': 'Segment',
    'Свойство события оплаты': 'Payment event property',
    'Условие': 'Condition',
    'Значение': 'Value',
    'содержит': 'contains',
    'одно из (через запятую)': 'one of (comma-separated)',
    '=': '=',
    '— выберите —': '— choose —',
    'Язык поручений': 'Command language',
    'Сохранить': 'Save',
    '«{term}» сохранено': '“{term}” saved',
    'Удалить «{term}» из словаря?': 'Delete “{term}” from the vocabulary?',
    'Пилот берёт отсюда отправителя, ссылку магазина и промокоды — других он не подставит. Изменение отправителя, хостов или кодов аннулирует открытые согласования.': 'Pilot takes the sender, shop link and promo codes from here — it will not substitute others. Changing the sender, hosts or codes voids open approvals.',
    'Отправитель (email)': 'Sender (email)',
    'сейчас: {email}': 'currently: {email}',
    'нужен подтверждённый домен': 'a verified domain is required',
    'Имя отправителя': 'Sender name',
    'Ссылка магазина (кнопка письма)': 'Shop link (email button)',
    'Разрешённые хосты ссылок': 'Allowed link hosts',
    'через запятую; другие ссылки в письме Пилот не поставит': 'comma-separated; Pilot will not put other links in the email',
    'Выданные промокоды': 'Issued promo codes',
    'через запятую; код не из списка Пилот не предложит': 'comma-separated; Pilot will not suggest a code that is not on the list',
    'Валюта': 'Currency',
    'Время «на сегодня» ({tz})': '“Today” send time ({tz})',
    'Согласование действует, ч': 'Approval valid for, h',
    'Вводить число получателей, если больше': 'Enter the recipient count if more than',
    'для больших рассылок согласующий набирает число вручную': 'for large campaigns the approver types the number manually',
    'AI-планировщик (если подключён на установке)': 'AI planner (if connected on this installation)',
    'Бюджет AI в месяц, $': 'AI budget per month, $',
    'пусто — по умолчанию установки': 'empty — the installation default',
    'Сейчас: {mode} · AI в этом месяце ${used} из ${limit} · команд сегодня {today} из {todayLimit}': 'Now: {mode} · AI this month ${used} of ${limit} · commands today {today} of {todayLimit}',
    'правила без AI — все функции доступны': 'rules without AI — all features available',
    'Голос.': 'Voice.',
    'Кнопка микрофона использует распознавание речи браузера: Chrome отправляет звук на серверы Google. MailOcean звук не получает и не хранит — только текст, который вы проверили и отправили.': 'The microphone button uses the browser’s speech recognition: Chrome sends the sound to Google’s servers. MailOcean does not receive or store the sound — only the text you checked and sent.',
    'Сохранено. Открытых согласований аннулировано: {n}': 'Saved. Open approvals voided: {n}',
    'Настройки Пилота сохранены': 'Pilot settings saved',
    'Сохранить настройки Пилота': 'Save Pilot settings',
    'Менять настройки Пилота могут владелец и администраторы.': 'Only the owner and admins can change the Pilot settings.',
  },
  uk: {
    'Бесплатная доставка для заказов от {sum}': 'Безкоштовна доставка для замовлень від {sum}',
    'Скидка {p}%': 'Знижка {p}%',
    'по промокоду {code}': 'за промокодом {code}',
    'Скидка {sum}': 'Знижка {sum}',
    'Без скидки': 'Без знижки',
    'русский': 'російська',
    'английский': 'англійська',
    'вы': 'ви',
    'участник команды': 'учасник команди',
    'система': 'система',
    'Подготовь на сегодня рассылку клиентам, которые покупали кофе больше месяца назад. Предложи бесплатную доставку от 40 евро. Пришли на согласование.': 'Підготуй сьогоднішню розсилку клієнтам, які купували каву понад місяць тому. Запропонуй безкоштовну доставку від 40 євро. Надішли на погодження.',
    'Убери слово «последний», спокойнее, исключи купивших за 7 дней.': 'Прибери слово «останній», зроби спокійніше, виключи тих, хто купував за 7 днів.',
    'Когда будет 100 кликов или 10 заказов, пришли отчёт.': 'Коли буде 100 кліків або 10 замовлень, надішли звіт.',
    'Рассылай.': 'Надсилай.',
    'нужен ответ': 'потрібна відповідь',
    'черновик': 'чернетка',
    'ждёт согласования': 'очікує погодження',
    'согласован': 'погоджено',
    'запланирован': 'заплановано',
    'идёт отправка': 'триває надсилання',
    'пауза': 'пауза',
    'передан в отправку': 'передано на надсилання',
    'окно пропущено': 'вікно пропущено',
    'остановлен MailOcean': 'зупинено MailOcean',
    'ждёт решения': 'очікує рішення',
    'согласовано': 'погоджено',
    'возвращено': 'повернуто',
    'аннулировано': 'анульовано',
    'отозвано': 'відкликано',
    'истекло': 'минуло',
    'ждёт времени отправки': 'очікує часу надсилання',
    'все письма созданы': 'усі листи створено',
    'уникальных кликов людей': 'унікальних кліків людей',
    'оплаченных заказов': 'оплачених замовлень',
    'атрибутированной выручки': 'атрибутованої виручки',
    'контакт удалён': 'контакт видалено',
    'нет email': 'немає email',
    'нет согласия': 'немає згоди',
    'частотный лимит': 'ліміт частоти',
    'в подавлениях': 'у придушеннях',
    'другое': 'інше',
    'Тема': 'Тема',
    'Прехедер': 'Прехедер',
    'Заголовок': 'Заголовок',
    'Текст': 'Текст',
    'Кнопка': 'Кнопка',
    'Ссылка кнопки': 'Посилання кнопки',
    'AI': 'AI',
    'правила': 'правила',
    'ручная правка': 'ручна правка',
    'Аудитория': 'Аудиторія',
    'Email': 'Email',
    'Web Push': 'Web Push',
    'Telegram-бот': 'Telegram-бот',
    'Мобильный push': 'Мобільний push',
    'AI выключен для пространства': 'AI вимкнено для простору',
    'ключ AI не настроен на этой установке': 'ключ AI не налаштовано на цій установці',
    'Работает детерминированный планировщик: весь сценарий доступен без AI': 'Детермінований планувальник: увесь сценарій працює без AI',
    'Планы предлагает модель; сервер проверяет каждое поле': 'Плани пропонує модель; сервер перевіряє кожне поле',
    'Правила (без AI)': 'Правила (без AI)',
    'Пилот выключен на этой установке.': 'Пілот вимкнено на цій установці.',
    'Пилот выключен на этой установке': 'Пілот вимкнено на цій установці',
    'Вы автор этой версии: согласовать её должен другой владелец или администратор пространства.': 'Ви автор цієї версії: погодити її має інший власник або адміністратор простору.',
    'Значения на карточке устарели или число получателей набрано неверно. Обновите карточку и сверьте числа.': 'Значення на картці застаріли або число отримувачів введено неправильно. Оновіть картку і звірте числа.',
    'Вы видели другую версию плана. Обновите поток.': 'Ви бачили іншу версію плану. Оновіть потік.',
    'План изменился, пока вы смотрели. Посмотрите последнюю версию.': 'План змінився, поки ви дивилися. Перегляньте останню версію.',
    'Это согласование уже не ждёт решения.': 'Це погодження вже не очікує рішення.',
    'Срок согласования истёк — запросите новое.': 'Строк погодження минув — запросіть нове.',
    'Согласование уже запрошено.': 'Погодження вже запитано.',
    'Согласовавший больше не владелец или администратор — нужно новое согласование.': 'Той, хто погодив, більше не власник або адміністратор — потрібне нове погодження.',
    'У этой версии нет действующего согласования.': 'Ця версія не має чинного погодження.',
    'Окно отправки пропущено: перенесите время в плане и согласуйте заново.': 'Вікно надсилання пропущено: перенесіть час у плані і погодьте знову.',
    'Отрисованное письмо отличается от согласованного — запуск остановлен. Создайте новую версию.': 'Відрендерений лист відрізняється від погодженого — запуск зупинено. Створіть нову версію.',
    'План уже запущен или закрыт — изменить его нельзя.': 'План уже запущено або закрито — змінити його не можна.',
    'Запуск остановлен MailOcean — возобновить его может только поддержка.': 'Запуск зупинено MailOcean — відновити його може лише підтримка.',
    'Запуск сейчас в другом состоянии. Обновите карточку.': 'Запуск зараз в іншому стані. Оновіть картку.',
    'Слишком много команд подряд — подождите немного.': 'Забагато доручень поспіль — почекайте трохи.',
    'Домен отправителя не подтверждён.': 'Домен відправника не підтверджено.',
    'Отправка заблокирована MailOcean.': 'Надсилання заблоковано MailOcean.',
    'Доступ к микрофону запрещён — разрешите его в настройках браузера или пишите текстом.': 'Доступ до мікрофона заборонено — дозвольте його в налаштуваннях браузера або пишіть текстом.',
    'Браузер не разрешает распознавание речи на этой странице — пишите текстом.': 'Браузер не дозволяє розпізнавання мовлення на цій сторінці — пишіть текстом.',
    'Не расслышал. Попробуйте ещё раз ближе к микрофону.': 'Не почув. Спробуйте ще раз ближче до мікрофона.',
    'Микрофон не найден.': 'Мікрофона не знайдено.',
    'Распознавание речи недоступно: нет связи с сервисом браузера.': 'Розпізнавання мовлення недоступне: немає зв’язку з сервісом браузера.',
    'Этот язык браузер не распознаёт.': 'Браузер не розпізнає цю мову.',
    'Распознавание остановилось ({code}).': 'Розпізнавання зупинилось ({code}).',
    'Например (сценарий из стратегии, по шагам):': 'Наприклад (сценарій зі стратегії, покроково):',
    'Слышу:': 'Чую:',
    'Поручение Пилоту: что, кому, когда и какой отчёт прислать': 'Доручення Пілоту: що, кому, коли і який звіт надіслати',
    'Поручение Пилоту': 'Доручення Пілоту',
    'Думаю…': 'Думаю…',
    'Отправить': 'Надіслати',
    'Текст распознан браузером — проверьте его перед отправкой. Голос не согласует и не запускает рассылку.': 'Текст розпізнано браузером — перевірте його перед надсиланням. Голос не погоджує і не запускає розсилку.',
    'Голосовой ввод недоступен в этом браузере — пишите текстом.': 'Голосове введення недоступне в цьому браузері — пишіть текстом.',
    'Идёт запись — отпустите, чтобы закончить': 'Триває запис — відпустіть, щоб завершити',
    'Нажмите и держите, чтобы говорить': 'Натисніть і тримайте, щоб говорити',
    'Нажмите и говорите (или держите пробел)': 'Натисніть і говоріть (або тримайте пробіл)',
    '{s} с / {max}': '{s} с / {max}',
    'Голос': 'Голос',
    'Отмена': 'Скасувати',
    'Язык распознавания': 'Мова розпізнавання',
    'Прочитать вслух (без адресов)': 'Прочитати вголос (без адресів)',
    'Прочитать': 'Прочитати',
    'Получателей': 'Отримувачів',
    'найдено {found} · исключено {excluded}': 'знайдено {found} · виключено {excluded}',
    'контрольная группа {n} (без письма)': 'контрольна група {n} (без листа)',
    'Отправка': 'Надсилання',
    'Предложение': 'Пропозиція',
    'Отчёт': 'Звіт',
    'Отправитель · языки': 'Відправник · мови',
    'Канал · цена': 'Канал · ціна',
    'бесплатно': 'безкоштовно',
    'до €{amount}': 'до €{amount}',
    'до {max} сообщений · {cost}': 'до {max} повідомлень · {cost}',
    'только получатели с адресом и согласием в этом канале': 'лише отримувачі з адресою та згодою в цьому каналі',
    'Лимит · оценка стоимости': 'Ліміт · оцінка вартості',
    'до {max} писем': 'до {max} листів',
    '≈ {sum}': '≈ {sum}',
    'без согласия {n}': 'без згоди {n}',
    'отписались {n}': 'відписалися {n}',
    'в подавлениях {n}': 'у списку придушення {n}',
    'без email {n}': 'без email {n}',
    'без адреса или согласия в канале {n}': 'без адреси або згоди в каналі {n}',
    'по исключениям плана {n}': 'за виключеннями плану {n}',
    'контрольная группа {n} — письма не получат': 'контрольна група {n} — листа не отримають',
    'Аудитория {eligible} (найдено {matched}; исключено {excluded}{details})': 'Аудиторія {eligible} (знайдено {matched}; виключено {excluded}{details})',
    'Предупреждения:': 'Попередження:',
    'Предпросмотр': 'Попередній перегляд',
    'Тёмная тема': 'Темна тема',
    'Письмо в тёмной теме почтового клиента (по стилям самого письма; клиенты, которые сами перекрашивают письма, покажут иначе)': 'Лист у темній темі поштового клієнта (за стилями самого листа; клієнти, що самі перефарбовують листи, покажуть інакше)',
    'Тема:': 'Тема:',
    'Письмо версии {v} ({lang})': 'Лист версії {v} ({lang})',
    'План · версия {v}': 'План · версія {v}',
    '{n} получателей · {send} · {offer}': '{n} отримувачів · {send} · {offer}',
    'заменена следующей версией': 'замінена наступною версією',
    'заменена': 'замінена',
    'Рассылка': 'Розсилка',
    'Кто собрал эту версию': 'Хто склав цю версію',
    'Хеш версии: согласование привязано к нему': 'Хеш версії: погодження прив’язане до нього',
    'Свернуть': 'Згорнути',
    'Словами:': 'Словами:',
    'Условие:': 'Умова:',
    'Исключить:': 'Виключити:',
    'Согласие, отписки и подавления проверяются ещё раз перед каждым письмом.': 'Згода, відписки та придушення перевіряються ще раз перед кожним листом.',
    'Допущения:': 'Припущення:',
    'Числа, ссылки и промокоды в письме — только из поручения и настроек Пилота.': 'Числа, посилання і промокоди в листі — лише з доручення та налаштувань Пілота.',
    'Изменить': 'Змінити',
    'Тестовое письмо': 'Тестовий лист',
    'Тестовое письмо отправлено на {email}': 'Тестовий лист надіслано на {email}',
    'На согласование': 'На погодження',
    'Версия {v} отправлена на согласование': 'Версію {v} надіслано на погодження',
    'Что изменилось': 'Що змінилося',
    'Версия {from} → {to}': 'Версія {from} → {to}',
    'Комментарий:': 'Коментар:',
    'Значимых изменений нет.': 'Суттєвих змін немає.',
    'Было:': 'Було:',
    'Стало:': 'Стало:',
    'Вошли {added}, вышли {removed}': 'Увійшли {added}, вийшли {removed}',
    'Текст заменён целиком.': 'Текст замінено повністю.',
    'Прежнее согласование не переносится.': 'Попереднє погодження не переноситься.',
    'Новая версия согласуется заново.': 'Нову версію треба погодити заново.',
    'Версия {v} согласована': 'Версію {v} погоджено',
    'Возвращено с комментарием': 'Повернуто з коментарем',
    'Согласование · версия {v}': 'Погодження · версія {v}',
    'Проверьте главное перед решением': 'Перевірте головне перед рішенням',
    'Запросил {who} · {at} · действует до {until} · хеш': 'Запросив {who} · {at} · діє до {until} · хеш',
    'Согласование относится только к этой версии; любая правка потребует нового.': 'Погодження стосується лише цієї версії; будь-яка правка потребуватиме нового.',
    'Это ваша версия. Если в пространстве есть другой владелец или администратор, согласует он; если нет — решение будет помечено «согласовано самостоятельно».': 'Це ваша версія. Якщо в просторі є інший власник або адміністратор, погоджує він; якщо ні — рішення буде позначено «погоджено самостійно».',
    'Введите число получателей': 'Введіть число отримувачів',
    '— для больших рассылок решение подтверждается набранным числом (больше {n}).': '— для великих розсилок рішення підтверджується введеним числом (більше {n}).',
    'число получателей': 'число отримувачів',
    'Комментарий (обязателен, если возвращаете)': 'Коментар (обов’язковий, якщо повертаєте)',
    'Комментарий к решению': 'Коментар до рішення',
    'Согласовать версию {v}': 'Погодити версію {v}',
    'Вернуть с комментарием': 'Повернути з коментарем',
    'Согласование не запускает рассылку: запуск — отдельная кнопка.': 'Погодження не запускає розсилку: запуск — окрема кнопка.',
    'Ждёт решения владельца или администратора пространства.': 'Очікує рішення власника або адміністратора простору.',
    'Согласование версии {v}:': 'Погодження версії {v}:',
    'изменились настройки Пилота': 'змінилися налаштування Пілота',
    'согласовано самостоятельно': 'погоджено самостійно',
    'самостоятельно': 'самостійно',
    'В пространстве нет второго владельца или администратора': 'У просторі немає другого власника або адміністратора',
    'Подготовить запуск…': 'Підготувати запуск…',
    'Запустить может владелец или администратор.': 'Запустити може власник або адміністратор.',
    'Запуск создан: письма уйдут в назначенное время': 'Запуск створено: листи підуть у призначений час',
    'Запуск создан: письма пошли в очередь': 'Запуск створено: листи поставлено в чергу',
    'Запуск': 'Запуск',
    'Запустить версию {v} для {n} получателей?': 'Запустити версію {v} для {n} отримувачів?',
    'Запуск уже создан — смотрите карточку отправки ниже.': 'Запуск уже створено — дивіться картку надсилання нижче.',
    'Эта карточка устарела: у плана другая версия или нет действующего согласования.': 'Ця картка застаріла: у плану інша версія або немає чинного погодження.',
    'Запустить': 'Запустити',
    'Отправка: {at}. Повторное нажатие не создаст второй запуск.': 'Надсилання: {at}. Повторне натискання не створить другого запуску.',
    'Запустить может владелец или администратор пространства.': 'Запустити може власник або адміністратор простору.',
    'передано провайдеру': 'передано провайдеру',
    'в очереди': 'у черзі',
    'неизвестно': 'невідомо',
    'прочие исходы': 'інші результати',
    'не будет отправлено': 'не буде надіслано',
    'Погружение рассылки · версия {v}': 'Занурення розсилки · версія {v}',
    'Старт {at}': 'Старт {at}',
    'Создано писем: {c} из {total}': 'Створено листів: {c} із {total}',
    'Остановлено MailOcean.': 'Зупинено MailOcean.',
    'Напишите в поддержку.': 'Напишіть у підтримку.',
    'создано': 'створено',
    'ждут создания': 'очікують створення',
    'контрольная группа': 'контрольна група',
    '«Передано провайдеру» не значит «доставлено». Письма с исходом «неизвестно» не повторяются автоматически, чтобы не было дублей.': '«Передано провайдеру» не означає «доставлено». Листи з результатом «невідомо» не повторюються автоматично, щоб не було дублів.',
    'Пауза: новые письма не создаются': 'Пауза: нові листи не створюються',
    'Пауза': 'Пауза',
    'Пауза и отменить очередь': 'Пауза і скасувати чергу',
    'Пауза и отмена писем в очереди? Отменённые письма не уйдут и при возобновлении. Письма, уже принятые провайдером, не отзываются.': 'Призупинити і скасувати листи в черзі? Скасовані листи не підуть і після відновлення. Листи, які вже прийняв провайдер, не відкликаються.',
    'Пауза, очередь отменена': 'Пауза, чергу скасовано',
    'Возобновить': 'Відновити',
    'Отправка возобновлена': 'Надсилання відновлено',
    'Отменить': 'Скасувати',
    'Отменить запуск? Письма, которые ещё не созданы или стоят в очереди, не уйдут. Это окончательно.': 'Скасувати запуск? Листи, які ще не створено або які стоять у черзі, не підуть. Це остаточно.',
    'Запуск отменён': 'Запуск скасовано',
    'Не будет отправлено: {list}.': 'Не буде надіслано: {list}.',
    'Запуск:': 'Запуск:',
    'Запуск создан:': 'Запуск створено:',
    'отменено в очереди: {n}': 'скасовано в черзі: {n}',
    'Жду любое из:': 'Чекаю будь-якого з:',
    'Жду все условия:': 'Чекаю всіх умов:',
    'Жду:': 'Чекаю:',
    'Без порога:': 'Без порогу:',
    'наблюдает': 'спостерігає',
    'сработал — отчёт отправлен': 'спрацював — звіт надіслано',
    'срок вышел — промежуточный итог': 'строк минув — проміжний підсумок',
    'отменён': 'скасовано',
    'Наблюдатель': 'Спостерігач',
    '{metric}: {now} из {gte}': '{metric}: {now} з {gte}',
    'сейчас {now}': 'зараз {now}',
    'Срок: до {at}; если порог не наберётся — придёт промежуточный итог с текущими числами.': 'Строк: до {at}; якщо поріг не набереться — прийде проміжний підсумок з поточними числами.',
    'Итог с текущими числами придёт {at}.': 'Підсумок з поточними числами прийде {at}.',
    'Сработал {at}.': 'Спрацював {at}.',
    'Срок был до {at}.': 'Строк був до {at}.',
    'Клики — только уникальные клики людей после фильтра ботов; открытия не считаются.': 'Кліки — лише унікальні кліки людей після фільтра ботів; відкриття не враховуються.',
    'Порог достигнут': 'Поріг досягнуто',
    'Промежуточный итог по сроку': 'Проміжний підсумок за строком',
    'Исправление отчёта': 'Виправлення звіту',
    'Отчёт · версия {v} · {reason}': 'Звіт · версія {v} · {reason}',
    'Есть исправленная версия {v} — смотрите ниже в потоке.': 'Є виправлена версія {v} — дивіться нижче в потоці.',
    'Исправлено:': 'Виправлено:',
    'версия {v} заменяет версию {from}': 'версія {v} замінює версію {from}',
    'заказов': 'замовлень',
    'возвратов': 'повернень',
    'Атрибутировано (не равно приросту)': 'Атрибутовано (не дорівнює приросту)',
    '{revenue} атрибутированных продаж': '{revenue} атрибутованих продажів',
    'заказ в течение {days} дн. после клика человека': 'замовлення протягом {days} дн. після кліку людини',
    'заказ в течение {days} дн. после письма, без клика': 'замовлення протягом {days} дн. після листа, без кліку',
    'возвратов {n} ({sum})': 'повернень {n} ({sum})',
    'Прирост (по контрольной группе)': 'Приріст (за контрольною групою)',
    'п.п.': 'п.п.',
    'с письмом {a}% ({b} из {c}) · без письма {d}% ({e} из {f})': 'з листом {a}% ({b} із {c}) · без листа {d}% ({e} із {f})',
    '95% интервал: {lo}…{hi} п.п. — {verdict}': '95% інтервал: {lo}…{hi} в.п. — {verdict}',
    'отличие значимо': 'різниця значуща',
    'отличие не доказано': 'різницю не доведено',
    'прирост не измеряется: нет контрольной группы': 'приріст не вимірюється: немає контрольної групи',
    'Клики': 'Кліки',
    'всего кликов {raw}: люди {human} · боты {bot} · сомнительные {suspect}': 'усього кліків {raw}: люди {human} · боти {bot} · сумнівні {suspect}',
    'проверяются {n}': 'перевіряються {n}',
    'Открытия не считаются (Apple MPP и почтовые прокси открывают письма сами).': 'Відкриття не враховуються (Apple MPP та поштові проксі відкривають листи самі).',
    'создано {c} · принято провайдером {a} · доставлено по событию провайдера {d}': 'створено {c} · прийнято провайдером {a} · доставлено за подією провайдера {d}',
    'неизвестно {n}': 'невідомо {n}',
    'в очереди {n}': 'у черзі {n}',
    'не отправлено: {list}': 'не надіслано: {list}',
    'Ссылка': 'Посилання',
    'Люди (уник.)': 'Люди (унік.)',
    'Боты': 'Боти',
    'Сомнительные': 'Сумнівні',
    'Оговорки и качество данных': 'Застереження та якість даних',
    'Период: {from} — {to} · версия плана {rev} · правила кликов v{rules}': 'Період: {from} — {to} · версія плану {rev} · правила кліків v{rules}',
    'Пересказ AI проверен по фактам отчёта': 'Переказ AI перевірено за фактами звіту',
    'Текст собран сервером из чисел отчёта': 'Текст зібрано сервером з чисел звіту',
    'Запомнить в словаре': 'Запам’ятати у словнику',
    'Можно ответить словами в поле ниже.': 'Можна відповісти словами в полі нижче.',
    'Голос, распознан браузером': 'Голос, розпізнано браузером',
    'уверенность {p}%': 'впевненість {p}%',
    'Ошибка': 'Помилка',
    'Изменить версию {v}': 'Змінити версію {v}',
    'Будет создана новая версия; согласование — заново.': 'Буде створено нову версію; погодження — знову.',
    'Изменений нет.': 'Змін немає.',
    'Создать версию {v}': 'Створити версію {v}',
    'Название': 'Назва',
    'Время отправки ({tz})': 'Час надсилання ({tz})',
    'Сразу после запуска': 'Одразу після запуску',
    'В назначенное время': 'У призначений час',
    'Дата': 'Дата',
    'Время': 'Час',
    'Канал': 'Канал',
    'Шаблон канала': 'Шаблон каналу',
    'Ключ шаблона из «Каналы → Шаблоны»; в нём только переменные одобренного текста: subject, heading, paragraph, button_label, url, offer': 'Ключ шаблону з «Канали → Шаблони»; у ньому лише змінні погодженого тексту: subject, heading, paragraph, button_label, url, offer',
    'Только бесплатные каналы и без каскада: получат только контакты с адресом и маркетинговым согласием в этом канале. Смена канала — новое согласование.': 'Лише безкоштовні канали, без каскаду: отримають лише контакти з адресою та маркетинговою згодою в цьому каналі. Зміна каналу потребує нового погодження.',
    'Тип предложения': 'Тип пропозиції',
    'Бесплатная доставка от суммы': 'Безкоштовна доставка від суми',
    'Скидка в процентах': 'Знижка у відсотках',
    'Скидка суммой': 'Знижка сумою',
    'Порог, {cur}': 'Поріг, {cur}',
    'Скидка, %': 'Знижка, %',
    'Скидка, {cur}': 'Знижка, {cur}',
    'Промокод': 'Промокод',
    'только выданные магазином (настройки Пилота)': 'лише видані магазином (налаштування Пілота)',
    'в настройках Пилота нет промокодов': 'у налаштуваннях Пілота немає промокодів',
    'без промокода': 'без промокоду',
    'Текст письма': 'Текст листа',
    'Язык письма': 'Мова листа',
    'На языке подписчика': 'Мовою передплатника',
    'Только по-русски': 'Лише російською',
    'Только по-английски': 'Лише англійською',
    'Русский': 'Російська',
    'Английский': 'Англійська',
    'только https и разрешённые в настройках хосты': 'лише https і хости, дозволені в налаштуваннях',
    'Футер с отпиской и причиной письма добавляется всегда. Чтобы изменить аудиторию, напишите команду в потоке — например «исключи купивших за 7 дней».': 'Футер з відпискою та причиною листа додається завжди. Щоб змінити аудиторію, напишіть доручення в потоці — наприклад «виключи тих, хто купував за 7 днів».',
    'Отчёт и измерение': 'Звіт і вимірювання',
    'Прислать отчёт по порогу': 'Надіслати звіт за порогом',
    'Порог: {metric}': 'Поріг: {metric}',
    'не задан': 'не задано',
    'Условия': 'Умови',
    'любое из': 'будь-що з',
    'все сразу': 'усі разом',
    'Если не наберётся — итог через, ч': 'Якщо не набереться — підсумок через, год',
    'Контрольная группа, %': 'Контрольна група, %',
    '0–20; без неё прирост не измеряется': '0–20; без неї приріст не вимірюється',
    'Лимит получателей': 'Ліміт отримувачів',
    'не меньше аудитории': 'не менше за аудиторію',
    'Комментарий к правке (необязательно)': 'Коментар до правки (необов’язково)',
    'Сервер не принял правку:': 'Сервер не прийняв правку:',
    'Пилот': 'Пілот',
    'Поручите рассылку словами или голосом: Пилот соберёт план с аудиторией и текстом, задаст вопросы, если что-то неясно, и пришлёт на согласование. Запускает всегда человек.': 'Доручіть розсилку словами або голосом: Пілот складе план з аудиторією і текстом, запитає, якщо щось незрозуміло, і надішле на погодження. Запускає завжди людина.',
    'Обратитесь к администратору MailOcean.': 'Зверніться до адміністратора MailOcean.',
    'Словарь': 'Словник',
    'Настройки Пилота': 'Налаштування Пілота',
    'Решения о запуске принимает человек.': 'Рішення про запуск ухвалює людина.',
    'Например: подготовь на завтра рассылку тем, кто не покупал 60 дней, скидка 10%, пришли на согласование': 'Наприклад: підготуй на завтра розсилку тим, хто не купував 60 днів, знижка 10%, надішли на погодження',
    'Роль «наблюдатель» только читает потоки.': 'Роль «спостерігач» лише читає потоки.',
    'Поручения': 'Доручення',
    'последние сверху': 'останні зверху',
    'Поручений ещё нет': 'Доручень ще немає',
    'Первое поручение — в поле выше. Пилот ничего не отправит без согласования и отдельного запуска.': 'Перше доручення — у полі вище. Пілот нічого не надішле без погодження й окремого запуску.',
    'есть план': 'є план',
    'без плана': 'без плану',
    'обновлено {when}': 'оновлено {when}',
    'Поток не найден.': 'Потік не знайдено.',
    'Все поручения': 'Усі доручення',
    'Пока пусто': 'Поки що порожньо',
    'Напишите поручение ниже или выберите пример.': 'Напишіть доручення нижче або оберіть приклад.',
    'Пилот разбирает поручение…': 'Пілот розбирає доручення…',
    'Роль «наблюдатель» только читает поток.': 'Роль «спостерігач» лише читає потік.',
    'Рассылка завершена или отменена — для новой начните новое поручение.': 'Розсилку завершено або скасовано — для нової розсилки почніть нове доручення.',
    'Ответьте на вопрос выше или напишите новое поручение': 'Дайте відповідь на питання вище або напишіть нове доручення',
    'Поток поручения': 'Потік доручення',
    'Пульт': 'Пульт керування',
    'плана ещё нет': 'плану ще немає',
    'Опишите рассылку: кому, что предложить, когда и какой отчёт прислать. Пилот соберёт план, но сам ничего не отправит.': 'Опишіть розсилку: кому, що запропонувати, коли і який звіт надіслати. Пілот складе план, але сам нічого не надішле.',
    'Версия': 'Версія',
    'Согласование': 'Погодження',
    'не запрошено': 'не запитано',
    'Обновлён': 'Оновлено',
    'Отменить план? Писем ещё не было; поток останется в истории.': 'Скасувати план? Листів ще не було; потік залишиться в історії.',
    'План отменён': 'План скасовано',
    'Отменить план': 'Скасувати план',
    'Словарь Пилота': 'Словник Пілота',
    'Как слова поручений связаны с вашими данными. Если слова нет в словаре, Пилот спросит, а не угадает.': 'Як слова доручень пов’язані з вашими даними. Якщо слова немає в словнику, Пілот запитає, а не вгадуватиме.',
    'Словарь пуст': 'Словник порожній',
    'Добавьте товар или группу клиентов — например «кофе» → категория coffee в событии оплаты.': 'Додайте товар або групу клієнтів — наприклад «кава» → категорія coffee у події оплати.',
    'Слово': 'Слово',
    'Значит': 'Означає',
    'Язык': 'Мова',
    'Добавлено': 'Додано',
    'товар: {f}': 'товар: {f}',
    'сегмент {s}': 'сегмент {s}',
    'любой': 'будь-який',
    'Удалить {term}': 'Видалити {term}',
    'Добавить слово': 'Додати слово',
    'Слово или фраза': 'Слово або фраза',
    'как вы пишете в поручениях: «кофе», «постоянные»': 'як пишете в дорученнях: «кава», «постійні»',
    'Товар': 'Товар',
    'Сегмент': 'Сегмент',
    'Свойство события оплаты': 'Властивість події оплати',
    'Условие': 'Умова',
    'Значение': 'Значення',
    'содержит': 'містить',
    'одно из (через запятую)': 'одне з (через кому)',
    '=': '=',
    '— выберите —': '— оберіть —',
    'Язык поручений': 'Мова доручень',
    'Сохранить': 'Зберегти',
    '«{term}» сохранено': '«{term}» збережено',
    'Удалить «{term}» из словаря?': 'Видалити «{term}» зі словника?',
    'Пилот берёт отсюда отправителя, ссылку магазина и промокоды — других он не подставит. Изменение отправителя, хостов или кодов аннулирует открытые согласования.': 'Пілот бере звідси відправника, посилання на магазин і промокоди — інших не підставить. Зміна відправника, хостів або кодів анулює відкриті погодження.',
    'Отправитель (email)': 'Відправник (email)',
    'сейчас: {email}': 'зараз: {email}',
    'нужен подтверждённый домен': 'потрібен підтверджений домен',
    'Имя отправителя': 'Ім’я відправника',
    'Ссылка магазина (кнопка письма)': 'Посилання на магазин (кнопка листа)',
    'Разрешённые хосты ссылок': 'Дозволені хости посилань',
    'через запятую; другие ссылки в письме Пилот не поставит': 'через кому; інші посилання Пілот у лист не вставить',
    'Выданные промокоды': 'Видані промокоди',
    'через запятую; код не из списка Пилот не предложит': 'через кому; Пілот не запропонує код, якого немає в списку',
    'Валюта': 'Валюта',
    'Время «на сегодня» ({tz})': 'Час «на сьогодні» ({tz})',
    'Согласование действует, ч': 'Погодження чинне, год',
    'Вводить число получателей, если больше': 'Вводити число отримувачів, якщо більше',
    'для больших рассылок согласующий набирает число вручную': 'для великих розсилок погоджувач вводить число вручну',
    'AI-планировщик (если подключён на установке)': 'AI-планувальник (якщо підключено на установці)',
    'Бюджет AI в месяц, $': 'Бюджет AI на місяць, $',
    'пусто — по умолчанию установки': 'порожньо — за замовчуванням установки',
    'Сейчас: {mode} · AI в этом месяце ${used} из ${limit} · команд сегодня {today} из {todayLimit}': 'Зараз: {mode} · AI цього місяця ${used} з ${limit} · доручень сьогодні {today} з {todayLimit}',
    'правила без AI — все функции доступны': 'правила без AI — усі функції доступні',
    'Голос.': 'Голос.',
    'Кнопка микрофона использует распознавание речи браузера: Chrome отправляет звук на серверы Google. MailOcean звук не получает и не хранит — только текст, который вы проверили и отправили.': 'Кнопка мікрофона використовує розпізнавання мовлення браузера: Chrome надсилає звук на сервери Google. MailOcean звук не отримує і не зберігає — лише текст, який ви перевірили й надіслали.',
    'Сохранено. Открытых согласований аннулировано: {n}': 'Збережено. Відкритих погоджень анульовано: {n}',
    'Настройки Пилота сохранены': 'Налаштування Пілота збережено',
    'Сохранить настройки Пилота': 'Зберегти налаштування Пілота',
    'Менять настройки Пилота могут владелец и администраторы.': 'Змінювати налаштування Пілота можуть власник і адміністратори.',
  },
};
